"use strict";
/**
 * Force Majeure (Fuerza mayor) Enums
 *
 * Single source of truth for force-majeure declaration scope.
 * A declaration marks a day (or range) as "fuerza mayor" for everyone or for a
 * single branch. Affected collaborators are paid full salary with their actual
 * scheduled hours computed. See GH#423.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FORCE_MAJEURE_SCOPE_LABELS = exports.ForceMajeureScope = void 0;
var ForceMajeureScope;
(function (ForceMajeureScope) {
    ForceMajeureScope["all"] = "all";
    ForceMajeureScope["branch"] = "branch";
})(ForceMajeureScope || (exports.ForceMajeureScope = ForceMajeureScope = {}));
/** Spanish display labels for ForceMajeureScope */
exports.FORCE_MAJEURE_SCOPE_LABELS = {
    [ForceMajeureScope.all]: 'Todas las sucursales',
    [ForceMajeureScope.branch]: 'Sucursal específica',
};
